import Cookies from 'js-cookie';

import { runSplitTest } from './runSplitTest';
import SPLIT_TESTS from './split_tests.json';
import { postLendingApiJson } from '../Pages/lendingApiFetch';

export type TBranch = { branchName: string; testPercentage: number };
export type TAnonymousSplitTest = (typeof SPLIT_TESTS)['tests'][number];
export type TSplitTestData = {
  test_name: string;
  branch_name: string;
  created: string;
  fraction: number;
  random_value: number;
};

function setProductionSplitTestCookies(data: TSplitTestData, siteURL: string) {
  Cookies.set(`iw-${data['test_name']}`, JSON.stringify(data), {
    domain: siteURL,
    expires: 7665,
  });
}

async function updateSplitTestData(data: TSplitTestData) {
  const cookieExists = !!Cookies.get(`iw-${data['test_name']}`);
  const isProd = window.location.hostname === 'iwoca.co.uk';

  if (cookieExists) return;

  if (isProd) {
    setProductionSplitTestCookies(data, 'https://iwoca.co.uk');
  } else {
    Cookies.set(`iw-${data['test_name']}`, JSON.stringify(data));
  }

  // Add record for this user
  await postLendingApiJson({
    url: '/api/split_tests/add_to_split_test/',
    body: data,
  });
}

export function getSplitTestBranch(
  splitTest: TAnonymousSplitTest,
): TSplitTestData {
  const testName = splitTest.name;
  const splitTestCookie = Cookies.get(`iw-${testName}`);

  if (splitTestCookie) {
    return JSON.parse(splitTestCookie);
  }

  const randomNumber = Math.random();
  const activeBranch = runSplitTest(splitTest, randomNumber);

  const currentDateTime = new Date();

  const splitTestData = {
    test_name: testName,
    branch_name: activeBranch.branchName,
    created: currentDateTime.toISOString(),
    fraction: activeBranch.testPercentage,
    random_value: randomNumber,
  };

  void updateSplitTestData(splitTestData);

  return splitTestData;
}

export const useGetSplitTests = ({
  testFilter,
  supportSplitTests = true,
}: {
  testFilter?: TAnonymousSplitTest['name'];
  supportSplitTests?: boolean;
} = {}) => {
  if (!supportSplitTests) return [];

  const tests = SPLIT_TESTS.tests.map((test) => {
    return getSplitTestBranch(test);
  });

  if (testFilter) return tests.filter((test) => test.test_name === testFilter);

  return tests;
};
